import { render, staticRenderFns } from "./querSuHighAfterListAction.vue?vue&type=template&id=580381e5&scoped=true"
import script from "./querSuHighAfterListAction.vue?vue&type=script&lang=js"
export * from "./querSuHighAfterListAction.vue?vue&type=script&lang=js"
import style0 from "./querSuHighAfterListAction.vue?vue&type=style&index=0&id=580381e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580381e5",
  null
  
)

export default component.exports